module.exports = __webpack_public_path__ + "img/Union.2012e537.svg";